import apiRequest from '.';
import { JSONObject } from '../types';
import { getUserData } from './getUserData';
import { ApiRequestArgsOptionalUserData } from './types';

export const browserApiRequest = <T = JSONObject>(args: ApiRequestArgsOptionalUserData) => {
	return apiRequest<T>({
		userData: getUserData(),
		...args,
	});
};
